module.exports = __webpack_public_path__ + "img/portal.2eecc5e1.svg";